<template lang="pug">
v-alert(
  type="success"
  text
)
  p.caption.mb-0 {{ notification.created_at | readableDateTime }}
  template(#close v-if="!notification.read_at")
    v-btn(
      @click="$emit('read', notification.id)"
      color="success"
      outlined
      icon
      small
      :loading="loadingId === notification.id"
    )
      v-icon(small) mdi-check
  template(
    v-if="notification.type === NOTIFICATION_TYPES.CLIENT_QUESTION"
  )
    | У вас новое обращение: &nbsp;
    router-link(:to="`/application/${notification.data.id}`")
      | {{ notification.data.text}}

  template(v-else-if="notification.type === NOTIFICATION_TYPES.CHAT_MESSAGE")
    router-link(:to="`/application/${notification.data.client_question_id}`")
      | У вас новое сообщение &nbsp;
  template(v-else-if="notification.type === NOTIFICATION_TYPES.TASK")
    router-link(:to="`/tasks/${notification.data.id}`")
      | {{notification.text}}

  template(v-else-if="notification.type === NOTIFICATION_TYPES.TRANSFER")
    router-link(:to="`/application/${notification.data.client_question_id}`")
      | Вам было передано обращение &nbsp;
    | от {{ cachedUser(notification.data.owner_id).username }}

  .d-flex(v-else-if="notification.type === NOTIFICATION_TYPES.INTERNAL_CHAT_MESSAGE")
    span.mr-1 У вас новое сообщение
    div.mr-1(v-html="notification.data.text")
    router-link(:to="`/application/${notification.data.internal_chat.target_id}`")
      | в чате с поддержкой &nbsp;

  .d-flex(v-else-if="notification.type === NOTIFICATION_TYPES.ADMIN_MESSAGE")
    span.mr-1 Вам сообщение от администратора:
    div(v-html="notification.data.text")

</template>

<script>
import mixinDateTime from '@/mixins/mixinDateTime';
import { mapGetters } from 'vuex';
import { NOTIFICATION_TYPES } from '@/store/modules/notification';

export default {
  mixins:[mixinDateTime],
  props:{
    notification:{ type:Object, required: true },
    loadingId:{ type: Number, required: false, default: null },
  },
  data() {
    return {
      NOTIFICATION_TYPES,
    };
  },
  computed:{
    ...mapGetters({
      'cachedUser':'cache/cachedUser',
    }),
  },

};
</script>

<style>

</style>
